import { Injectable } from '@angular/core';
import { environment as env } from './../../../environments/environment';
import { type Pet } from '../../shared/models/pet.model';
import { type Pagination } from '../../shared/models/pagination.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { withDateAdapter, withDateAdapterPage } from '../../shared/rxjs/with-date-adapter';

@Injectable({
  providedIn: 'root'
})
export class PetService {
  private readonly endpoint = `${env.baseAPIUrl}/pet`;

  private readonly dateFields = ['birthdate', 'createdAt', 'updatedAt', 'deletedAt'];
  private readonly transformDate = withDateAdapter<Pet>(this.dateFields);
  private readonly transformDatePage = withDateAdapterPage<Pagination<Pet>>(this.dateFields);

  constructor(private readonly http: HttpClient) { }

  getPetById(petId: string): Observable<Pet> {
    return this.http.get<Pet>(`${this.endpoint}/${petId}`).pipe(this.transformDate);
  }

  paginatePets(page: number, size: number=10): Observable<Pagination<Pet>> {
    return this.http.get<Pagination<Pet>>(`${this.endpoint}?page=${page}&pageSize=${size}`).pipe(this.transformDatePage);
  }

  paginatePetsByUser(userId: string, page: number, size: number=10): Observable<Pagination<Pet>> {
    return this.http.get<Pagination<Pet>>(`${this.endpoint}/user/${userId}?page=${page}&pageSize=${size}`).pipe(this.transformDatePage);
  }

  paginatePetsByUserWithoutCode(userId: string, page: number, size: number=10): Observable<Pagination<Pet>> {
    return this.http.get<Pagination<Pet>>(`${this.endpoint}/without-qrcode/${userId}?page=${page}&pageSize=${size}`).pipe(this.transformDatePage);
  }

  createPet(pet: FormData): Observable<Pet> {
    return this.http.post<Pet>(`${this.endpoint}`, pet).pipe(this.transformDate);
  }

  updatePet(pet: FormData): Observable<Pet> {
    return this.http.patch<Pet>(`${this.endpoint}/${pet.get('id')}`, pet).pipe(this.transformDate);
  }

  deletePet(petId: string): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${petId}`);
  }
}
